import { sha, describe } from "~build/git";
import * as borogove from "borogove";

export const About = () => {
	return (
		<section>
			<h1>About</h1>
			<p>
				This is AGPLv3 licensed software, version{" "}
				<a href={import.meta.env.VITE_SOURCE_URL.replace(/%SHA%/, sha)}>
					{describe}
				</a>
				. Based on{" "}
				<a href="https://borogove.dev">Borogove {borogove.VERSION}</a>
			</p>
			<p>This is an alpha test version.</p>
		</section>
	);
};
